<template>
    <div class="cherry-blossoms" aria-hidden="true">
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
        <div class="cherry-blossom">
            <div class="inner">🌸</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CherryBlossoms",
    data() {
        return {};
    },
    mounted() {
    },
    computed: {},
    watch: {},
    methods: {
        //
    },
};
</script>

<style scoped lang="scss">
/* customizable cherry-blossom styling */
.cherry-blossom {
    color: #fff;
    font-size: 1em;
    font-family: Arial, sans-serif;
    text-shadow: 0 0 5px #000;
}

.cherry-blossom, .cherry-blossom .inner {
    animation-iteration-count: infinite;
    animation-play-state: running
}

@keyframes cherry-blossoms-fall {
    0% {
        transform: translateY(0)
    }
    100% {
        transform: translateY(110vh)
    }
}

@keyframes cherry-blossoms-shake {
    0%, 100% {
        transform: translateX(0)
    }
    50% {
        transform: translateX(80px)
    }
}

.cherry-blossom {
    position: fixed;
    top: -10%;
    z-index: 9999;
    -webkit-user-select: none;
    user-select: none;
    cursor: default;
    animation-name: cherry-blossoms-shake;
    animation-duration: 3s;
    animation-timing-function: ease-in-out
}

.cherry-blossom .inner {
    animation-duration: 10s;
    animation-name: cherry-blossoms-fall;
    animation-timing-function: linear
}

.cherry-blossom:nth-of-type(0) {
    left: 1%;
    animation-delay: 0s
}

.cherry-blossom:nth-of-type(0) .inner {
    animation-delay: 0s
}

.cherry-blossom:first-of-type {
    left: 10%;
    animation-delay: 1s
}

.cherry-blossom:first-of-type .inner, .cherry-blossom:nth-of-type(8) .inner {
    animation-delay: 1s
}

.cherry-blossom:nth-of-type(2) {
    left: 20%;
    animation-delay: .5s
}

.cherry-blossom:nth-of-type(2) .inner, .cherry-blossom:nth-of-type(6) .inner {
    animation-delay: 6s
}

.cherry-blossom:nth-of-type(3) {
    left: 30%;
    animation-delay: 2s
}

.cherry-blossom:nth-of-type(11) .inner, .cherry-blossom:nth-of-type(3) .inner {
    animation-delay: 4s
}

.cherry-blossom:nth-of-type(4) {
    left: 40%;
    animation-delay: 2s
}

.cherry-blossom:nth-of-type(10) .inner, .cherry-blossom:nth-of-type(4) .inner {
    animation-delay: 2s
}

.cherry-blossom:nth-of-type(5) {
    left: 50%;
    animation-delay: 3s
}

.cherry-blossom:nth-of-type(5) .inner {
    animation-delay: 8s
}

.cherry-blossom:nth-of-type(6) {
    left: 60%;
    animation-delay: 2s
}

.cherry-blossom:nth-of-type(7) {
    left: 70%;
    animation-delay: 1s
}

.cherry-blossom:nth-of-type(7) .inner {
    animation-delay: 2.5s
}

.cherry-blossom:nth-of-type(8) {
    left: 80%;
    animation-delay: 0s
}

.cherry-blossom:nth-of-type(9) {
    left: 90%;
    animation-delay: 1.5s
}

.cherry-blossom:nth-of-type(9) .inner {
    animation-delay: 3s
}

.cherry-blossom:nth-of-type(10) {
    left: 25%;
    animation-delay: 0s
}

.cherry-blossom:nth-of-type(11) {
    left: 65%;
    animation-delay: 2.5s
}
</style>